'use client'
import { ReactNode, useState } from 'react'
import BlankLayout from 'src/@core/layouts/BlankLayout'
import { styled, ThemeProvider } from '@mui/material/styles'
import theme from 'src/utils/themeManagementVersion2'
import ManagementRegistrationConfirmation from 'src/components/ui_parts/u-miru/registration/confirmation'
import ManagementRegistrationComponent from 'src/components/ui_parts/u-miru/registration'
import { Box } from '@mui/material'

const RegistrationPage = () => {
  const [isConfirmation, setIsConfirmation] = useState(false)
  const handleSubmit = () => {
    setIsConfirmation(true)
  }
  const handleBack = () => {
    setIsConfirmation(false)
  }

  const BaseBox = styled(Box)({
    width: '100%',
    height: '100vh',
    backgroundImage: 'url(/registration_bg.png)',
    backgroundSize: '100% auto',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'bottom',
  })

  return (
    <ThemeProvider theme={theme}>
      <BaseBox>
        {!isConfirmation ? (
          <ManagementRegistrationComponent onSubmit={handleSubmit} />
        ) : (
          <ManagementRegistrationConfirmation onBack={handleBack} />
        )}
      </BaseBox>
    </ThemeProvider>
  )
}

RegistrationPage.getLayout = (page: ReactNode) => <BlankLayout>{page}</BlankLayout>

export default RegistrationPage
